import { css } from "@emotion/react";
import { bpoints } from "../../../../Utils";

export function chooseOptionBuro() {
  return css`
    .TextContainer {
      display: flex;
      flex-direction: column;
      z-index: 1;

      //margin-top: calc(1rem + 1.5vh);

      text-align: center;

      font-size: calc(10px + 1vw);

      /* background: linear-gradient(90deg, #204B7B 0%, #32B8DF 31.04%, #00BA6E 100%); */
      background: #204b7b;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      @media (max-width: ${bpoints.mobile.w}px) {
        padding: 0 10%;
        font-size: calc(16px + 1vw);

        span {
          display: contents;
        }
      }
    }
    .ExtraInfo {
    font-size: calc(16px + (18 - 16) * ((100vw - 320px) / (1920 - 320))); /* Tamaño del texto adicional */
    color: #888; /* Color más discreto */
    margin-left: 5px; /* Espacio entre el texto principal y el texto adicional */
}

.ContainetBtn{
    width: 60%;
    justify-content: center;
    min-width: 200px;
    display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
}

@media (max-width: ${bpoints.mobile.w}px) {
  .ContainetBtn{
    width: 100%;
    align-items: center;
}
}


    .ButtonSection2 {
      margin:  auto;
      display: flex;
      flex-direction: column;
      gap: 5.2vh;
      align-items: center;
      width: 100%;

      .TextRow {
        display: flex;
        flex-direction: column;
        text-align: center;

        .BoldSmall {
          color: #000;
          font-style: normal;
          font-weight: 600;
          font-size: calc(1rem + 0.5vw);
          line-height: 134.48%;

          margin-bottom: 1.6vh;

          @media (max-width: ${bpoints.mobile.w}px) {
            font-size: calc(1rem + 1.4vw);
            margin-bottom: 3vh;
          }
        }

        .NormalMedium {
          font-size: calc(1.1rem + 0.8vw);
          font-style: normal;
          font-weight: 500;
          line-height: 105.405%;

          @media (max-width: ${bpoints.mobile.w}px) {
            font-size: calc(1.5rem + 4.5vw);
            padding: 0 1.2rem;
          }
        }

        .NormalLarge {
          color: #000;
          font-style: normal;
          font-weight: 500;
          font-size: calc(1rem + 1.1vw);
          line-height: 134.48%;

          margin-bottom: 1.6vh;

          @media (max-width: ${bpoints.mobile.w}px) {
            font-size: calc(1.5rem + 4.5vw);
            margin-bottom: 2.6vh;
          }
        }

        .SmallGray {
          font-size: calc(0.8rem + 0.5vw);
          font-style: normal;
          font-weight: 500;
          line-height: 105.405%;

          color: #77787b;

          @media (max-width: ${bpoints.mobile.w}px) {
            font-size: calc(1rem + 1.1vw);
            color: black;
            margin-bottom: 4vh;
          }
        }
      }

      .ButtonRow {
        width: calc(9rem + 28vw);
        display: flex;
        gap: calc(2rem + 1vw);
        color: white;
        font-weight: 500;
        font-size: calc(1.1rem + 0.6vw);
        letter-spacing: 0.74px;
        justify-content: center;


        @media (max-width: ${bpoints.mobile.w}px) {
          flex-direction: column;
          gap: 15px;
          font-size: calc(1.3rem + 1.5vw);
          width: 70%;
        }

      
        .Button {
          position: relative;
          cursor: pointer;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          padding: 1.5rem 0;

          flex-basis: 0;
          flex-grow: 1;

          //transition: 300ms;
        }

        .Green {
          background-color: #22ec9a;
          :hover {
            background-color: #2ad690;
          }
        }

        .Blue {
          background-color: #32b8df;
        }

        .GradientLeft {
          border: none;
          outline: none;
          background: linear-gradient(to right, #34c6f1, #00ba6e);
          z-index: 1;
          //transition: 200ms;
          min-height: 94px;

          :hover {
            background: #22ec9a;
          }

          ::before {
            content: "";
            position: absolute;
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
            border-radius: 23px;
            background-color: white;
            z-index: -1;
            transition: 200ms;
          }

          ::after {
            content: attr(data);

            color: #00ba6e;
            transition: 200ms;
          }
        }

        .GradientLeft:hover::before {
          background-color: #22ec9a;
        }

        .GradientLeft:hover::after {
          color: #fff;
        }

        .GradientRight {
          border: none;
          outline: none;
          background: linear-gradient(to left, #34c6f1, #00ba6e);
          z-index: 1;

          :hover {
            background: #32b8df;
          }

          ::before {
            content: "";
            position: absolute;
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
            border-radius: 23px;
            background-color: white;
            z-index: -1;
            transition: 200ms;
          }

          ::after {
            content: attr(data);

            color: #21588c;
            transition: 200ms;
          }
        }

        .GradientRightGrey {
          border: none;
          outline: none;
          // background: linear-gradient(to left, #34c6f1, #00ba6e);
          background: #d8d8d8;
          z-index: 1;

          :hover {
            background: #b5b2b2;
          }

          ::before {
            content: "";
            position: absolute;
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
            border-radius: 23px;
            background-color: white;
            z-index: -1;
            border-color: #b5b2b2;
            transition: 200ms;
          }

          ::after {
            content: attr(data);

            color: #cbc8c8;
            transition: 200ms;
          }
        }

        .GradientRight:hover::before {
          background-color: #32b8df;
        }

        .GradientRight:hover::after {
          color: #fff;
        }
      }

      .Shadow {
        margin-top: -1rem;
        border-radius: 837px;
        background: radial-gradient(
          50.94% 44.66% at 49.86% 50.14%,
          rgba(0, 0, 0, 0.12) 0%,
          rgba(217, 217, 217, 0) 100%
        );
        width: 90%;
        height: 3rem;
        margin-left: auto;
        margin-right: auto;
        margin: 1rem 0
      }
    }
    .DocumentsReminder {
      margin-top: 2rem;
      padding: 1.5rem;
      background-color: rgba(52, 185, 224, 0.05);
      border-radius: 12px;
      width: 90%;
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }

    .ReminderTitle {
      color: #204b7b;
      font-size: 1.2rem;
      margin-bottom: 1rem;
      text-align: center;
    }

    .ReminderColumns {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      gap: 1rem;
    }

    .ReminderColumn {
      flex: 1;
      min-width: 250px;
    }

    .ReminderColumn h5 {
      color: #34b9e0;
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    .ReminderColumn ul {
      list-style: none;
      padding-left: 0;
    }

    .ReminderColumn li {
      color: #666;
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
      position: relative;
      padding-left: 1.2rem;
    }

    .ReminderColumn li:before {
      content: "•";
      color: #34b9e0;
      position: absolute;
      left: 0;
    }

    @media (max-width: 768px) {
      .ReminderColumns {
        flex-direction: column;
      }
      
      .ReminderColumn {
        margin-bottom: 1.5rem;
      }
    }
  .ButtonWithShadow {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    align-items: center;
    margin-top: 2rem;

    .Green {
      background-color: #22EC9A;
      color: white;
      font-size: calc(0.4rem + 0.7vw);
      border-radius: 17px !important;
      border: unset !important;
      width: fit-content;
      padding: 0 6rem;
      min-height: 50px;
      
      :hover {
        background-color: #2ad690;
      }
    }
    
    .Shadow {
      width: 50%;
      height: 55px;
      border-radius: 467px;
      background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
    }
  }

  @media (max-width: 768px) {
    .ButtonWithShadow {
      .Green {
        width: 80%;
        font-size: calc(0.9rem + 0.9vw);
      }
      
      .Shadow {
        width: 80%;
      }
    }
  }
  .PersonsContainer {
    width: 95%;
    max-width: 1400px;
    margin: 0 auto;
  }

  .PersonsGrid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 2rem;
  }

  .PersonCard {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 1.5rem;
    border: 2px solid #E5E5E5;
    border-radius: 15px;
    width: 30%;
    flex: 1;
    min-width: 320px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: white;
    justify-content: flex-start;
    gap: 1.5rem;
    box-sizing: border-box;

    @media (max-width: 1024px) {
      width: 45%;
      flex: unset;
    }

    @media (max-width: 768px) {
      width: 90%;
      flex-direction: column;
      gap: 20px;
    }
  }

  .PersonCard:hover {
    border-color: #1FDD8F;
  }

  .PersonCard.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .PersonCard.disabled img {
    filter: grayscale(100%);
  }

  .PersonImg {
    width: 80px;
    height: 80px;
    margin-bottom: 1rem;
  }

  .PersonTitle {
    color: #204b7b;
    font-weight: 600;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .PersonDescription {
    color: #666;
    font-size: 0.9rem;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .RequirementsContainer {
    width: 100%;
    background-color:rgba(32, 74, 123, 0.05);
    border-radius: 8px;
    padding: 1rem;
    margin-top: auto;
    
  }

   .RequirementItem {
      color: #666;
      font-size: 0.8rem;
      margin-bottom: 0.5rem;
      position: relative;
      padding-left: 1.2rem;
    }

  .RequirementsTitle {
    color: #204b7b;
    font-weight: 600;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .RequirementsList {
    list-style: none;
    padding-left: 0;
  }

  .RequirementsList li {
    color: #204b7b;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    position: relative;
    padding-left: 1.2rem;
    font-weight: 600;
  }

  .RequirementsList li:before {
    content: "•";
    color: #1FDD8F;
    position: absolute;
    left: 0;
  }

  .RequirementsList.TwoColumns {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .RequirementsList.TwoColumns li {
    width: 100%;
    
    @media (min-width: 768px) {
      width: 100%;
    }
  }

  .person-transition-enter {
    opacity: 0;
    transform: scale(0.9);
  }

  .person-transition-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms ease-in, transform 300ms ease-in;
  }

  .person-transition-exit {
    opacity: 1;
    transform: scale(1);
  }

  .person-transition-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms ease-out, transform 300ms ease-out;
  }

  @media (max-width: 768px) {
    .PersonsGrid {
      flex-direction: column;
      align-items: center;
    }
    
    .PersonCard {
      width: 80%;
      max-width: none;
    }
  }
  `;
}
